function parseAnswer(response) {
    if (response && response.data && response.data.step ) {
        return response.data.step
    }
    return "login";
}

module.exports = parseAnswer;